import Text from "@/components/common/Typography/Text";
import { Card, CardProps, Col, Row, Skeleton } from "antd";


type HotelDealItemSkeletonProps = CardProps & {
  itemType?: "sample" | "default";
  hiddenImage?: boolean;
  styles?: any
};

const HotelDealItemSkeleton = ({
  hiddenImage,
  className,
  itemType = "default",
  ...props
}: HotelDealItemSkeletonProps) => {

  return (
    <Card
      className={`${className ? `${className} ` : ""}`}
      cover={
        !hiddenImage && (
          <Skeleton.Image
            active
            style={{
              height: '20rem',
              width: '100%'
            }}
            styles={{
              root: {
                width: '100%',
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                background: '#fff'
              },
              content: {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
              }
            }}
          />
        )
      }
      style={{
        minHeight: '100%'
      }}
      styles={{
        ...props.styles,
        body: {
          padding: "1.2rem",
          display: "flex",
          flexDirection: "column",
          ...props.styles?.body,
        },
      }}
      {...props}
    >
      <Row style={{ minHeight: '14.4rem' }}>
        <Col span={24}>
          <Row style={{ marginBottom: '0.5rem' }}>
            <Skeleton
              paragraph={false}
              styles={{
                title: {
                  width: '100%',
                  height: '2.4rem',
                  margin: 0
                }
              }}
              active
            />
          </Row>
          <Row style={{ marginBottom: '0.5rem' }}>
            <Skeleton
              paragraph={false}
              styles={{
                title: {
                  width: '100%',
                  height: '2rem',
                  margin: 0
                }
              }}
              active
            />
          </Row>
          <Row gutter={5} wrap={false}>
            {Array(5).fill(null).map((_, idx) => {
              return (
                <Col key={idx}>
                  <Text className="home__deals-hotels--item-star">
                    <Skeleton
                      paragraph={false}
                      styles={{
                        title: {
                          width: '1.6rem',
                          height: '1.6rem',
                          margin: 0
                        }
                      }}
                      active
                    />
                  </Text>
                </Col>
              )
            })}
          </Row>
        </Col>
        <Col style={{ alignSelf: 'end' }} span={24}>
          <Row justify="end">
            <Col>
              <Skeleton
                paragraph={false}
                styles={{
                  title: {
                    margin: 0,
                    width: '8rem',
                    height: '2.2rem'
                  }
                }}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: 5 }} align="middle" gutter={[10, 10]} justify="end">
            <Col>
              <Skeleton
                paragraph={false}
                styles={{
                  title: {
                    margin: 0,
                    width: '7rem',
                    height: '2.5rem'
                  }
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
};

export default HotelDealItemSkeleton
